var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleUnlinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 30.2H33.2V33.9H38.7C38.6 34.8 38 36.2 36.7 37.1C35.9 37.7 34.7 38.1 33.2 38.1C30.6 38.1 28.3 36.4 27.5 33.9C27.3 33.3 27.2 32.6 27.2 31.9C27.2 31.2 27.3 30.5 27.5 29.9C27.6 29.7 27.6 29.5 27.7 29.4C28.6 27.3 30.7 25.8 33.2 25.8C35.1 25.8 36.3 26.6 37.1 27.3L39.9 24.5C38.1999 23 35.9 22 33.2 22C29.3 22 25.9 24.2 24.3 27.5C23.6 28.9 23.2 30.4 23.2 32C23.2 33.6 23.6 35.1 24.3 36.5C25.9 39.8 29.3 42 33.2 42C35.9 42 38.1999 41.1 39.7999 39.6C41.6999 37.9 42.7999 35.3 42.7999 32.2C42.7999 31.4 42.7 30.8 42.6 30.2Z",
    stroke: "#ABABAB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleUnlinked);
export default __webpack_public_path__ + "static/media/google-unlinked.00e1ad5ffbbf6b339c6defdc80a2e2fd.svg";
export { ForwardRef as ReactComponent };